import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

// Declaration of PRESETS module with using MODULES SCHEMA
export default {
	[ModulesConfigMap[ModulesMap.PRESETS].GET_PRESETS]: {
		url: '/company/:companyId/presets/:instanceName/',
	},
	[ModulesConfigMap[ModulesMap.PRESETS].GET_MULTIPLE_PRESETS]: {
		url: '/company/:companyId/presets/multiple/',
	},
	[ModulesConfigMap[ModulesMap.PRESETS].CREATE_PRESET]: {
		url: '/company/:companyId/presets/:instanceName/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.PRESETS].DELETE_PRESET]: {
		url: '/company/:companyId/presets/:instanceName/:presetId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
	[ModulesConfigMap[ModulesMap.PRESETS].EDIT_PRESET]: {
		url: '/company/:companyId/presets/:instanceName/:presetId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.PRESETS].PATCH_PRESET]: {
		url: '/company/:companyId/presets/:instanceName/:presetId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	/** можно передать query параметр conflict_policy со значениями:
	 * add_if_not_exists - добавит такой пресет если его нет
	 * replace_all - если уже есть у стафа такой пресет - то он они удалятся и будет создан новый
	 */
	[ModulesConfigMap[ModulesMap.PRESETS].CLONE_TO_COMPANY_PRESET]: {
		url: '/company/:companyId/presets/:instanceName/:presetId/clone_to_company/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.PRESETS].CHANGE_PRESETS_ORDER]: {
		url: '/company/:companyId/presets/:instanceName/reorder/',
		requestOptions: {
			method: 'PATCH',
		},
	},
}
